/**
 * Client copy of the locked S0 keepsake protocol constants
 * (PC-B rev 9). CROSS-BOUNDARY MIRROR (rule #4): the server copy is
 * `api/_lib/keepsake/constants.ts`; scripts/probe-keepsake-parity.mjs
 * asserts equality on the shared values. Change both in lockstep.
 */

export const IDENTITY_MODE_CR_BASELINE = 'cr-baseline-v1' as const;
export const CR_BASELINE_FRONTIER = 'cr-baseline-v1:none' as const;
export const PROTOCOL_VERSION = 1 as const;
export const NORMALIZER_VERSION = 'who-key-v1' as const;
export const FOLD_VERSION = 'cr-empty-fold-v1' as const;

/** The CR empty projection pin digest (PC-B section 7a.5). */
export const CR_PROJECTION_DIGEST =
  '6255e3348fac8bd4f6cfa7fd742a9d869dc053713de62b3d998e93b51980bd14' as const;

export const STRINGS_VERSION = 'keepsake-strings-v1' as const;

export type KeepsakeLocale = 'en-US' | 'es-MX' | 'pt-BR';

/** i18n language -> keepsake protocol locale. */
export function keepsakeLocaleFor(language: string | undefined): KeepsakeLocale {
  const base = (language ?? 'en').slice(0, 2).toLowerCase();
  if (base === 'es') return 'es-MX';
  if (base === 'pt') return 'pt-BR';
  return 'en-US';
}

/** Job locator query key + tab-scoped sessionStorage key (PC-B 10a.2). */
export const JOB_LOCATOR_QUERY_KEY = 'keepsakeJob' as const;
export const JOB_LOCATOR_SESSION_KEY = 'adia-keepsake-open-job-v1' as const;

/** The in-memory release capability tuple values (PC-B 15 decision 5). */
export const RELEASE_CONTAINMENT = 'pc-b-cr-v1' as const;
export const RELEASE_KEEPSAKE_ENVELOPE = 1 as const;
